import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AppConfiguration } from './app-configuration.service';

import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';


@Injectable()
export class ServiceBase implements HttpInterceptor  {
  constructor(public http: HttpClient,
              public auth: AuthService,
              public configuration: AppConfiguration,
              private router: Router

) {
  this.apiUrl = configuration.apiUrl;

}

apiUrl: string;

  getUrlApi(controller: string, params?): string{

    if (params){
      return this.apiUrl + controller + '/' + params.join('/')
    }else{
      return this.apiUrl + controller + '/'
    }
  }


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.auth.getToken()}`
      }
    });



    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => event),
      catchError((error: HttpErrorResponse) => {
          if (error && error.status === 401)
          {
            this.router.navigate(['login']);
          }
          return throwError(error);
      }));

    //return next.handle(request);
  }

  public getCommonHeaders(): Headers {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
  }
  public postCommonHeaders(): any {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })};

    return httpOptions;
  }



  public handleError(err: HttpErrorResponse): any {
    return throwError(err.error);
  }

}
